// extracted by css-extract-rspack-plugin
export default {"restoreLink":"ProjectItemSectionFieldList-module__restoreLink__Ldo5r"};